// extracted by mini-css-extract-plugin
module.exports = {"header":"EYELW","logo":"_00KW0","nav-item":"uCWem","shape":"FKcCV","name":"UNemz"};